export default function Routing() {
    return (
        <iframe src="https://synctivate.quickbase.com/db/btye8buzj?a=dbpage&pageID=2" title="Routing Tool" width="100%" height="100%"></iframe>
    )
}